import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { SimpleLoadingComponent } from '../../utils/apollo';
import CollegeEventFilterComponent from './eventFilter';
import collegeEventFilterFragment from '../CollegeEventsEditEvent/graphql/collegeEventFilterFragment';
import './styles.css';

const query = gql`
  query collegeEventFilters {
    viewer {
      id
      eventFilters {
        ...CollegeEventFilter
      }
    }
  }
  ${collegeEventFilterFragment}
`;

const graphqlData = graphql(query, { options: { fetchPolicy: 'cache-and-network' } });

export default SimpleLoadingComponent(graphqlData)(CollegeEventFilterComponent);
